import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white text-brand-ink" data-id="element-90" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-91" data-mp="9tbdguhw0kh8">
        <p className="text-xs font-semibold uppercase tracking-widest text-brand-blue" data-id="element-92" data-mp="et6735t1ro5z">
          Tu inversión está protegida
        </p>

        <Reveal className="mt-2 flex items-start gap-3 rounded-2xl border-2 border-brand-green bg-brand-mist p-3 text-left" data-id="element-93" data-mp="jrr7p6c7o9uy">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-brand-green" data-id="element-94" data-mp="ns1c4ekcus7p">
            <ShieldCheckIcon size={20} className="text-white" data-id="element-95" data-mp="sn6yfeho68wb" />
          </span>
          <div data-id="element-96" data-mp="xj5tfkxi6p5p">
            <h2 id="garantia" className="font-display text-base font-bold uppercase leading-tight text-brand-blue sm:text-lg" data-id="element-97" data-mp="xlrwb79g8ghl">
              🛡️ Garantía total de 7 días
            </h2>
            <p className="mt-0.5 text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-98" data-mp="25sgitgp7wc1x">
              Tenés 7 días para explorar los 6 tomos y los 5 bonos. Si
              considerás que el sistema no es adecuado para vos, podés
              solicitar un reembolso dentro del período establecido según los
              términos de devolución.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}